import { tv } from 'tailwind-variants';

export default tv({
  base: 'w-60 hover:bg-white focus:bg-white',
});
